import React from "react";
import { BCMSDate, BCMSDefaultModel, DisabledPrompt, Link, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, useRoute } from "bcms-react";
import Classes, { Account, Payee, WireHistory } from "model";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import MobileMultiWireTable from './components/MobileMultiWireTable';
import MultiWireTable from './components/MultiWireTable';
import "./mobile.css";
import "./styles.css";

/**
 * @function MultipleWiresPage
 * @return {React.Component}
 * @exported true
 * @description The page for Multiple Wires
 */

export default function MultipleWiresPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: (prop, selectedWireHistory) => value => {
        const indexOfWireHistory = WireHistory.initAll().findIndex(wireHistory => wireHistory.id === selectedWireHistory.id);
        const copyPayee = Payee.init({ ...selectedWireHistory.payee.record });
        const copyWire = WireHistory.init({ ...selectedWireHistory.record });
        copyWire.payee = copyPayee;
        copyWire[prop] = value;
        const copyWires = [ ...data.wires ];

        const newWires = [ 
          ...copyWires.slice(0, indexOfWireHistory),
          copyWire,
          ...copyWires.slice(indexOfWireHistory + 1, copyWires.length) 
        ];
        
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "wires" ], newWires)
        .submit(setState);
      },

      // "Save" functionality is currently disabled.
      onSave: () => {}
  });

  return(
    <PageContainer className="multiple-wires-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => {
  const payees = Payee.initAll();

  let wires = payees.reduce((acc, payee) => {
    const defaultWire = BCMSDefaultModel.wireHistory();
    defaultWire.payee = payee;
    defaultWire.id = payee.id;
    defaultWire.fundingAccount = Account.initAllAsset().filter(item => item.type === "checking")[0]
    acc.push(defaultWire)
    return acc;
  }, []);

  return {
    wires: wires
  }
};
export const getDefaultUI = () => ({
  // no ui changes for now
});

function PageContent(props) {
  const { data, ui, onChange, onSave } = useStateManager();
  const wires = data.wires ?? [];
  
  const payeeDesktopTables = wires.reduce((acc, wire) => {
    acc.push(<MultiWireTable key={ wire.id } wire={ wire } />);
    return acc;
  }, []);

  const payeeMobileTables = wires.reduce((acc, wire) => {
    acc.push(<MobileMultiWireTable key={ wire.id } wire={ wire } />);
    return acc;
  }, []);

  return (
  <PageContentView>
    <CenterContentContainer>
      <ContentHeaderView text="Multiple Wires" />
      <div className="show-on-desktop">
        { payeeDesktopTables }
      </div>
      <div className="show-on-mobile">
        { payeeMobileTables }
      </div>
      <DisabledPrompt>
        <PrimaryButton text="Submit" />
      </DisabledPrompt>
      
    </CenterContentContainer>
  </PageContentView>
  );
}